export default {
  graduation: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/graduations/resources/props.js